<header id="cx-header" class="cx-header-desktop" cxSkipLink="cx-header" [cxFocus]="{ disableMouseFocus: true }">
  <div class="container">
    <div class="content">
      <cx-page-layout section="beforeHeader"></cx-page-layout>

      <div class="main">
        <cx-page-layout section="siteLogo"></cx-page-layout>
        <cx-page-layout section="headerAux"></cx-page-layout>
      </div>
    </div>
  </div>
</header>
